import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入 ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/layout-theme.css'
import '@/styles/business-dialog.css'
import '@/assets/styles/plugin-shell-embed.css'
import axios from 'axios'

// 引入进度条样式
import 'nprogress/nprogress.css'
import { setAmapSecurityConfig } from '@/utils/amapConfig'
import dayjs from 'dayjs';
// 引入高德地图插件
import AMapPlugin from './plugins/amap';
import { clearAllPluginRetainOnAppStart } from '@/utils/pluginPageRetain'

// 刷新/重新打开应用时清空插件页跨会话缓存（旧版 sessionStorage 残留）
clearAllPluginRetainOnAppStart()

// 在应用启动时设置安全密钥
setAmapSecurityConfig()
// 全局注册 ElementUI
Vue.use(ElementUI)
Vue.use(AMapPlugin); // 注册高德地图插件，使this.$createAMap生效
Vue.config.productionTip = false
// 全局挂载dayjs
Vue.prototype.$dayjs = dayjs;

// 旧版原始 axios 请求也走当前后端，第三方回调和地图请求不附带本站鉴权。
axios.interceptors.request.use((config) => {
  if (!/^\/(?:truck|web\/truck)\//.test(config.url || '')) return config
  const apiBaseUrl = String(process.env.VUE_APP_BASE_API || '').replace(/\/+$/, '')
  const requestBaseUrl = String(config.baseURL || '').replace(/\/+$/, '')
  if (requestBaseUrl && requestBaseUrl !== apiBaseUrl) return config
  if (process.env.NODE_ENV === 'production') config.baseURL = apiBaseUrl
  config.withCredentials = true
  const token = localStorage.getItem('token_bearer')
  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 统一处理后端“data.error”错误结构（适用于所有 await axios.*）
axios.interceptors.response.use(
  (response) => {
    try {
      const body = response && response.data ? response.data : null
      const err = body && body.data && body.data.error != null ? String(body.data.error).trim() : ''
      if (err) {
        body.msg = err
        body.success = false
      }
    } catch (e) {
      /* ignore */
    }
    return response
  },
  (error) => Promise.reject(error)
)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
